export default __webpack_public_path__ + "static/Palmolive-11378dabdb56afcb5ad2bd021e4fbdaf.png";